const Preloader = () => {
  return (
    <div className='w-full flex justify-center items-center absolute top-0 left-0 right-0 bottom-0 m-auto z-50'>
        <div className="bg-Naranja-Ticongle p-2 w-4 h-4 rounded-full animate-bounce blue-circle m-1"></div>
        <div className="bg-Naranja-Ticongle p-2 w-4 h-4 rounded-full animate-bounce green-circle m-1"></div>
        <div className="bg-Naranja-Ticongle p-2 w-4 h-4 rounded-full animate-bounce red-circle m-1"></div>
    </div>
  );
}	

export default Preloader;